<template>
  <crud-editor
    ref="editor"
    :definition="definition"
    :is-edit="isEdit"
    :auto-generated-id="false"
    :save="saveData"
    :return-to="returnTo"
    :item-type="entity"
  />
</template>

<script>
import CrudEditor from '@/components/crud/Editor';
import formMixin from './form-mixin';

export default {
  components: {
    CrudEditor
  },
  mixins: [formMixin],
  data: () => ({
    isEdit: false
  }),
  methods: {
    saveData(form) {
      const item = this.createItemFromFormData(this, form);
      return this.$store.dispatch(this.entityStore + '/persistItem', item);
    }
  }
};
</script>
